"use strict";
/**
 * @class OuiConfiguration
 * @description Provides a configuration context to downstream components
 *    and manages change language behavior to support non-default languages
 *    default config values are stored in state then updated with actual values from the prop to trigger re-render
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Messages = require("../codegen/Messages");
var Environment_1 = require("@oui/core/Environment");
var ScreenReaderOnly_1 = require("@oui/core/ScreenReaderOnly");
var hg_ds_tokens_1 = require("@oui/hg-ds-tokens");
var util_1 = require("../utils/util");
var types_1 = require("./types");
var OuiConfiguration = /** @class */ (function (_super) {
    __extends(OuiConfiguration, _super);
    function OuiConfiguration(props) {
        var _this = _super.call(this, props) || this;
        _this.setAssertiveMessage = function (message) {
            _this.setState({ assertiveMessage: message });
        };
        _this.setPoliteMessage = function (message) {
            _this.setState({ politeMessage: message });
        };
        /**
         * Performs init language callbacks on loom-i18n package in oui-react
         *   plus any change language callbacks from other packages (e.g. oui-savant)
         * @param language
         */
        _this.initLanguage = function (language) {
            // unload screen till we change the UI
            Messages.init(language);
            // initialize other packages
            if (OuiConfiguration.registeredInitLanguageCallbacks.length > 0) {
                OuiConfiguration.registeredInitLanguageCallbacks.map(function (init) {
                    return init(language);
                });
            }
        };
        /**
         * Performs language callbacks on loom-i18n package in oui-react
         *   plus any change language callbacks from other packages (e.g. oui-savant)
         * @param language
         */
        _this.changeLanguage = function (language) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // unload screen till we change the UI
                    return [4 /*yield*/, Messages.changeLanguage(language)];
                    case 1:
                        // unload screen till we change the UI
                        _a.sent();
                        if (!(OuiConfiguration.registeredChangeLanguageCallbacks.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, Promise.all(OuiConfiguration.registeredChangeLanguageCallbacks.map(function (callback) {
                                return callback(language);
                            }))];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        /**
         * Performs init theme callbacks on loom-i18n package in oui-react
         *   plus any change theme callbacks from other packages (e.g. oui-savant)
         * @param theme
         */
        _this.initTheme = function (themeName) {
            _this.setTheme(themeName);
        };
        /**
         * Performs theme state change causing re-render
         * @param themeName
         */
        _this.setTheme = function (themeName) {
            var update = function (theme) {
                _this.setState(function (state) { return (__assign({}, state, { theme: theme })); }, function () {
                    document.body.id = themeName;
                });
            };
            switch (themeName) {
                case "hg":
                    Promise.resolve().then(function () { return require("@oui/hg-ds-tokens"); }).then(function (module) {
                        update(module.default);
                    });
                    break;
                case "redwood":
                    Promise.resolve().then(function () { return require("@oui/redwood-ds-tokens"); }).then(function (module) {
                        update(module.default);
                    });
                    break;
                default:
                    throw new Error("should never reach here");
            }
        };
        var value = _this.props.value;
        var currentLanguage = value.language || types_1.DefaultConfigurationValues.language;
        var currentTheme = value.themeName || types_1.DefaultConfigurationValues.themeName;
        _this.initLanguage(currentLanguage);
        _this.initTheme(currentTheme);
        _this.state = { language: currentLanguage, theme: hg_ds_tokens_1.default };
        return _this;
    }
    OuiConfiguration.registerChangeLanguageCallback = function (callback) {
        OuiConfiguration.registeredChangeLanguageCallbacks.push(callback);
    };
    OuiConfiguration.registerInitLanguageCallback = function (callback) {
        OuiConfiguration.registeredInitLanguageCallbacks.push(callback);
    };
    OuiConfiguration.prototype.componentWillReceiveProps = function (nextProps) {
        // listen to updates to language
        if (nextProps.value.language !== this.props.value.language) {
            var currentLanguage = nextProps.value.language || types_1.DefaultConfigurationValues.language;
            this.changeLanguage(currentLanguage);
        }
    };
    OuiConfiguration.prototype.render = function () {
        if (!this.state.theme)
            return null;
        var _a = this.state, language = _a.language, theme = _a.theme, politeMessage = _a.politeMessage, assertiveMessage = _a.assertiveMessage;
        var value = this.props.value;
        var context = {
            language: value.language || types_1.DefaultConfigurationValues.language,
            // theme: value.theme || DefaultConfigurationValues.theme,
            portalClass: value.portalClass
        };
        return (React.createElement(types_1.OuiConfigurationContextProvider, { value: context },
            React.createElement(types_1.OuiAriaLiveContext.Provider, { value: {
                    setPoliteMessage: this.setPoliteMessage,
                    setAssertiveMessage: this.setAssertiveMessage
                } },
                React.createElement(Environment_1.default, { theme: theme, environment: { generateInternalId: util_1.uniqueGUID }, key: language },
                    React.createElement(ScreenReaderOnly_1.default, null,
                        React.createElement("div", { "aria-live": "polite", role: "log", "data-test-id": "ariapolitemessage" }, politeMessage),
                        React.createElement("div", { "aria-live": "assertive", role: "log", "data-test-id": "ariaassertmessage" }, assertiveMessage)),
                    this.props.children))));
    };
    // static members to allow for registration of change language and theme callbacks when other packages (like oui-savant) load
    OuiConfiguration.registeredChangeLanguageCallbacks = [];
    OuiConfiguration.registeredInitLanguageCallbacks = [];
    return OuiConfiguration;
}(React.PureComponent));
exports.default = OuiConfiguration;
//# sourceMappingURL=OuiConfiguration.js.map